<template>


  <el-card class="introduction-card">
    <div class="card-header">关于本站</div>
    <p>
      本站的建立源于狮子开设的小型超市 <span class="highlight">5257</span>，然而，原物价网长达半年未进行数据更新，这促使我萌生了创建一个独立物价查询平台的想法。
    </p>
    <p>
      在此过程中，我们有幸联系到 <strong>奶瓶</strong> 并进行友好沟通。他愿意持续提供数据更新，并开发对外接口，从而促成了本站的诞生。
    </p>
    <p>
      目前，由于多方面因素，官方数据更新趋于停滞，仅进行部分固定活动及新家具的日常维护，用户获取物价信息的渠道变得有限。希望本站的建立，能够为广大用户提供更便捷的信息查询服务，帮助更多人获取所需数据并解决相关问题。
    </p>
    <p>
      特别感谢 <strong>奶瓶</strong> 在数据采集与维护方面的贡献。本站的<strong> 价格查询数据 </strong>仍由奶瓶进行维护，如需进一步新增或更新，敬请联系奶瓶。
    </p>
    <p>
      本站的初衷在于打造一个便捷、可靠的信息平台，期待与每一位用户相遇，并共同留下美好回忆。
    </p>
  </el-card>
  <el-card class="introduction-card2">
    <div class="card-header">更新记录</div>
    <el-timeline class="timeline-card">
      <el-timeline-item center timestamp="2025/2/16" placement="top" color='var(--adil-green)'>
        <el-card>
          <h4>初始化网页端，接入物价数据。</h4>
        </el-card>
      </el-timeline-item>
      <el-timeline-item center timestamp="2025/2/20" placement="top" color='var(--adil-green)'>
        <el-card>
          <h4>新增自由评论功能。</h4>
        </el-card>
      </el-timeline-item>
      <el-timeline-item center timestamp="2025/3/12" placement="top" color='var(--adil-green)'>
        <el-card>
          <h4>1.新增经验计算、批量注册工具。</h4>
          <h4>2.整体展示、服装展示、家具展示界面功能开发。</h4>
          <h4>3.游戏资料维护技能基本介绍，咖啡基础使用。</h4>
        </el-card>
      </el-timeline-item>
      <el-timeline-item timestamp="开发中" placement="top">
        <el-card>
          <h4>游戏资料进一步完善、举报功能开发。</h4>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    
  </el-card>
  <div class="introduction-card2">
      <twikoo-comment :env-id="TWIKOO_ENV_ID" path="/about" />
    </div>
  <!-- 评论组件放在外面 -->

</template>

<script>
import TwikooComment from '../components/TwikooComment.vue'
import { TWIKOO_ENV_ID } from '../config/twikoo'

export default {
  name: 'AboutPage',
  components: {
    TwikooComment
  },
  setup() {
    return {
      TWIKOO_ENV_ID
    }
  }
};
</script>

<style scoped>
.introduction-card {
  width: 80%;
  /* 改为百分比宽度 */
  max-width: 1200px;
  /* 设置最大宽度 */
  margin: 0 auto;
  margin-top: 5vh;
  /* 使用视窗高度的百分比 */
  padding: 2rem;
  background-color: var(--adil-card-bg);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.introduction-card2 {
  width: 80%;
  /* 改为百分比宽度 */
  max-width: 1200px;
  /* 设置最大宽度 */
  margin: 0 auto;
  margin-top: 2vh;
  padding: 2rem;
  background-color: var(--adil-card-bg);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 让 header 加粗、居中，并使用相对单位 */
.card-header {
  font-weight: 700;
  font-size: 2.25rem;
  /* 36px -> 2.25rem */
  text-align: center;
  line-height: 1.2;
  margin-bottom: 1.5rem;
}

/* 变色样式 */
.highlight {
  color: var(--adil-blue);
  font-weight: bold;
}

/* 添加段落换行的间距 */
p {
  line-height: 2;
  margin-bottom: 1rem;
  font-size: 1rem;
}

/* 响应式适配 */
@media (max-width: 768px) {

  .introduction-card,
  .introduction-card2 {
    width: 90%;
    padding: 1.5rem;
    margin-top: 3vh;
  }

  .card-header {
    font-size: 1.5rem;
  }

  p {
    font-size: 0.9rem;
    line-height: 1.8;
  }
}

/* 小屏幕设备的额外适配 */
@media (max-width: 480px) {

  .introduction-card,
  .introduction-card2 {
    width: 95%;
    padding: 1rem;
  }

  .card-header {
    font-size: 1.25rem;
  }

  p {
    font-size: 0.85rem;
    line-height: 1.6;
  }
}
</style>
